export const getSizeStyles = (size) => {
  switch (size) {
    case 'sm':
      return { width: '40px', height: '40px', borderWidth: '4px' };
    case 'lg':
      return { width: '80px', height: '80px', borderWidth: '8px' };
    case 'md':
    default:
      return { width: '60px', height: '60px', borderWidth: '6px' };
  }
};

export const getColor = (theme, colorKey) => {
  if (!theme || !theme.colors) return '#0056b3'; // Fallback color
  if (!colorKey) return theme.colors.brand.primary;
  if (colorKey === 'inherit') return 'inherit';
  if (colorKey === 'transparent') return 'transparent';
  
  // Accept nested keys like "brand.primary" or "feedback.success" if needed
  const keys = colorKey.split('.');
  if (keys.length === 2) {
    return (theme.colors[keys[0]] && theme.colors[keys[0]][keys[1]]) || theme.colors.brand.primary;
  }
  return theme.colors.brand[colorKey] || theme.colors.brand.primary;
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Loading/utils/loadingHelpers.js